// extracted by mini-css-extract-plugin
module.exports = {"center":"NumericWidget_center__1BHGU","subTitle":"NumericWidget_subTitle__2tM5m"};